import { useMemo } from 'react'

import { StatusBadge, Table } from '@domain-group/suit-theme'
import type { Column } from '@domain-group/suit-theme/dist/components/Table'

import useSelector from '@hooks/useSelector'

import type { CampaignPortalSyncModel } from '@models/types'

import type { EntitiesState } from '@redux/entities'

import CampaignPortalSyncsActions from './CampaignPortalSyncsActions'

interface CampaignPortalSyncsTableProps {
  campaignPortalSyncs: CampaignPortalSyncModel[],
}

const buildColumns = (portals: EntitiesState['portals']): Column[] => [
  {
    title: 'Action',
    // @ts-expect-error TS2322
    dataKey: 'sync_type',
    cellProps: {
      style: { textTransform: 'capitalize' },
      width: 140,
    },
  },
  {
    title: 'Portal',
    // @ts-expect-error TS2322
    dataKey: 'portal_id',
    // @ts-expect-error TS2322
    render: (portal_id: number) => portals[portal_id]?.title,
  },
  {
    title: 'Identity Code',
    // @ts-expect-error TS2322
    dataKey: 'identity_code',
    cellProps: {
      width: 140,
    },
  },
  {
    title: 'Unique ID',
    // @ts-expect-error TS2322
    dataKey: 'unique_id',
    cellProps: {
      width: 140,
    },
  },
  {
    title: 'Date and Time',
    // @ts-expect-error TS2322
    dataKey: 'dates.synced.date_time',
    cellProps: {
      width: 150,
    },
  },
  {
    title: 'Status',
    cellProps: {
      textAlign: 'center',
    },
    // @ts-expect-error TS2322
    dataKey: 'success',
    render: success => (
      <StatusBadge
        key={success}
        color={success ? 'green' : 'orange'}
        ghost
        text={success ? 'SUCCESS' : 'FAIL'}
      />
    ),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      width: 80,
      textAlign: 'center',
    },
    // @ts-expect-error TS2322
    render: id => <CampaignPortalSyncsActions campaignPortalSync={{ id }} />,
  },
]

const CampaignPortalSyncsTable = (props: CampaignPortalSyncsTableProps) => {
  const { campaignPortalSyncs } = props

  const portals = useSelector(reduxState => reduxState.entities.portals)

  const memoColumns = useMemo((): Column[] => buildColumns(portals), [campaignPortalSyncs.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 300, overflowY: 'auto' }}
      columns={memoColumns}
      scroll={{ x: 900 }}
      // @ts-expect-error TS2322
      data={campaignPortalSyncs}
      stickyHeader
    />
  )
}

export default CampaignPortalSyncsTable
